export default __webpack_public_path__ + "static/media/ysbth.b93ddf21.ttf";